import { useTranslation } from "react-i18next";
import Tooltip from "components/Tooltip";
import { getBooleanName } from "utils";

interface TextCellProps {
  value: string | number | null | boolean | string[] | number[];
  count?: string | number;
}

export default function TextCell({ value, count }: TextCellProps) {
  const { t } = useTranslation();

  if (Number(count) > 1) {
    return (
      <div className="flex justify-between text-gray-500">
        <span className="text-sm font-medium">
          {t("mappingEditor.different")}
        </span>
        <Tooltip content={t("mappingEditor.differentValuesTooltip")}></Tooltip>
      </div>
    );
  }

  let propertyValue = value;
  if (typeof value === "boolean") {
    propertyValue = getBooleanName(value) as string;
  }
  if (Array.isArray(value)) {
    propertyValue = value.join(", ");
  }

  return <>{propertyValue ?? "-"}</>;
}
